import { ArrowDown, ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal, SectionLabel } from "./Motion";
import { useGo } from "./Nav";
import { HouseCompare } from "./HouseCompare";
import { RenovationGuide } from "./RenovationGuide";
import { useT } from "@/i18n";

const CHAPTERS = [
  ["01", "#modelli", "Modelli chiavi in mano"],
  ["02", "#sistemi", "Telaio o X-LAM"],
  ["03", "#case-salutari", "Case salutari"],
  ["04", "#bioedilizia", "Bioedilizia"],
  ["05", "#ristrutturazione", "Ristrutturazione ed efficientamento"],
];

const Chapter = ({ n, id, label, go, t }) => (
  <button onClick={() => go(id)} className="group flex w-full items-center justify-between gap-4 border-t border-[#121110]/15 py-5 text-left transition-colors duration-300 hover:border-[#C26D38]" data-testid={`house-chapter-${id.slice(1)}`}>
    <span className="flex items-baseline gap-4">
      <span className="font-mono text-xs text-[#C26D38]">{n}</span>
      <span className="font-display text-xl font-bold tracking-tight sm:text-2xl">{t(`house.c.${id.slice(1)}`, label)}</span>
    </span>
    <ArrowDown className="h-5 w-5 shrink-0 text-[#6E685E] transition-transform duration-300 group-hover:translate-y-1 group-hover:text-[#C26D38]" />
  </button>
);

export const CasaInLegno = () => {
  const t = useT();
  const go = useGo();
  return (
    <section id="casa-in-legno" className="bg-[#F7F5F0] px-5 pt-28 text-[#121110] sm:px-8 lg:pt-40" data-testid="house-section">
      <div className="mx-auto grid max-w-[1500px] gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionLabel index="⌂">{t("house.label", "La casa in legno")}</SectionLabel>
          <MaskLines className="mt-10 font-display text-4xl font-bold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
            lines={[t("house.h1", "La casa in legno,"), <em key="e" className="font-serif font-normal text-[#C26D38]">{t("house.h2", "dal progetto alle chiavi.")}</em>]} />
          <Reveal className="mt-8 max-w-xl text-base leading-relaxed text-[#3D3833] sm:text-lg" data-testid="house-intro">
            {t("house.p", "Tutto quello che serve per scegliere la tua casa in legno, in un solo posto: i modelli chiavi in mano, i due sistemi costruttivi (telaio e X-LAM), il comfort di una casa salutare e i vantaggi della bioedilizia.")}
          </Reveal>
        </div>
        <nav className="lg:col-span-5 lg:self-end" aria-label={t("house.label", "La casa in legno")} data-testid="house-chapters">
          {CHAPTERS.map(([n, id, label]) => <Chapter key={id} n={n} id={id} label={label} go={go} t={t} />)}
          <button onClick={() => go("/pannelli-xlam")} className="flex w-full items-center justify-between gap-4 border-y border-[#121110]/15 py-5 text-left text-[#C26D38] transition-colors duration-300 hover:text-[#121110]" data-testid="house-chapter-xlam-page">
            <span className="font-mono text-xs uppercase tracking-[0.2em]">{t("house.xlam", "Schede e calcolo dei pannelli X-LAM")}</span>
            <ArrowUpRight className="h-5 w-5 shrink-0" />
          </button>
        </nav>
      </div>
      <HouseCompare />
      <RenovationGuide />
    </section>
  );
};
